import { Input, InputLabel } from "@material-ui/core";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
	${({ theme }) => css`
		height: auto;
	`}
`;

export const Error = styled.div`
	${({ theme }) => css`
		color: red;
	`}
`;

export const Content = styled.div`
	${({ theme }) => css`
		height: auto;
		padding-top: 20px;
		margin-bottom: 50px;
		z-index: 2999;

		.button-open-filter {
			width: 100%;
			align-self: center;
			background-color: ${theme.palette.primary.main};
			color: ${theme.palette.secondary.main};
			text-transform: capitalize;
			position: fixed;
			z-index: 999;
			bottom: 0px;
			right: 0px;
			left: 0px;
		}
	`}
`;

export const LoadText = styled.span`
	${({ theme }) => css`
		font-size: 28px;
		font-weight: 800;
		color: #545454;
		height: 60px;
		display: flex;
		align-items: center;
	`}
`;

export const Container = styled.div`
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

export const ConstructionAnimation = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 60px 0;
		position: relative;
	`}
`;

export const Hotel = styled.div`
	${({ theme }) => css`
		position: relative;
		width: 150px;
		margin-bottom: 42px;
		animation: hotelFloat 3s ease-in-out infinite;

		.moon {
			position: absolute;
			top: -30px;
			right: 4px;
			width: 22px;
			height: 22px;
			border-radius: 50%;
			background: radial-gradient(circle at 35% 35%, #fff3c4, #ffd25e);
			box-shadow: 0 0 12px rgba(255, 210, 94, 0.7);
			animation: twinkle 2.6s ease-in-out infinite;
		}

		.star {
			position: absolute;
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background: #ffd25e;
			opacity: 0.5;
			animation: twinkle 1.8s ease-in-out infinite;
		}
		.star-1 { top: -34px; left: 16px; animation-delay: 0.3s; }
		.star-2 { top: -18px; left: 54px; animation-delay: 1s; }

		.roof {
			height: 16px;
			border-radius: 10px 10px 0 0;
			background: ${theme.palette.primary.main};
		}

		.facade {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 12px;
			padding: 16px;
			background: #ffffff;
			border: 2px solid #e6e6e6;
			border-top: none;
			border-radius: 0 0 12px 12px;
			box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
		}

		.windows {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 10px;
			width: 100%;
		}

		.window {
			height: 24px;
			border-radius: 3px;
			background: #dce3ea;
			animation: windowLight 2.7s ease-in-out infinite;
		}
		.window:nth-child(1) { animation-delay: 0s; }
		.window:nth-child(2) { animation-delay: 0.15s; }
		.window:nth-child(3) { animation-delay: 0.3s; }
		.window:nth-child(4) { animation-delay: 0.45s; }
		.window:nth-child(5) { animation-delay: 0.6s; }
		.window:nth-child(6) { animation-delay: 0.75s; }
		.window:nth-child(7) { animation-delay: 0.9s; }
		.window:nth-child(8) { animation-delay: 1.05s; }
		.window:nth-child(9) { animation-delay: 1.2s; }

		.door {
			width: 30px;
			height: 34px;
			border-radius: 6px 6px 0 0;
			background: ${theme.palette.primary.main};
			position: relative;
		}
		.door::after {
			content: '';
			position: absolute;
			top: 50%;
			right: 5px;
			width: 3px;
			height: 3px;
			border-radius: 50%;
			background: rgba(255, 255, 255, 0.9);
		}

		@keyframes hotelFloat {
			0%, 100% { transform: translateY(0); }
			50% { transform: translateY(-6px); }
		}

		@keyframes twinkle {
			0%, 100% { opacity: 0.4; transform: scale(0.85); }
			50% { opacity: 1; transform: scale(1); }
		}

		@keyframes windowLight {
			0%, 100% {
				background: #dce3ea;
				box-shadow: none;
			}
			45%, 65% {
				background: #ffcf6b;
				box-shadow: 0 0 10px rgba(255, 200, 90, 0.75);
			}
		}
	`}
`;

export const ConstructionText = styled.div`
	${({ theme }) => css`
		font-size: 24px;
		font-weight: 700;
		color: ${theme.palette.primary.main};
		margin-bottom: 10px;
		animation: pulse 2s ease-in-out infinite;
		
		@keyframes pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.7; }
		}
	`}
`;

export const ConstructionSubtext = styled.div`
	${({ theme }) => css`
		font-size: 16px;
		color: #666;
		text-align: center;
		max-width: 400px;
		line-height: 1.5;
	`}
`;

export const CarLoaderAnimation = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 60px 0;
	gap: 28px;
`;

export const CarLoaderText = styled.p`
	font-size: 20px;
	font-weight: 700;
	color: #333;
	text-align: center;
	margin: 0;
	max-width: 420px;
	line-height: 1.4;
`;

export const CarScene = styled.div`
	${({ theme }) => css`
	width: 340px;
	max-width: 90vw;

	.car {
		position: relative;
		width: 120px;
		margin: 0 auto 14px;
		animation: carBounce 0.35s ease-in-out infinite alternate;
	}

	.cabin {
		width: 80px;
		height: 28px;
		background: ${theme.palette.primary.dark || theme.palette.primary.main};
		border-radius: 10px 10px 0 0;
		margin: 0 auto;
		display: flex;
		align-items: flex-start;
		gap: 8px;
		padding: 6px 8px 0;
	}

	.window {
		flex: 1;
		height: 18px;
		background: rgba(255, 255, 255, 0.3);
		border-radius: 3px 3px 0 0;
	}

	.body {
		width: 120px;
		height: 38px;
		background: ${theme.palette.primary.main};
		border-radius: 4px 4px 6px 6px;
		position: relative;
	}

	.headlight {
		position: absolute;
		right: 0;
		top: 10px;
		width: 10px;
		height: 9px;
		background: #fde68a;
		border-radius: 2px 0 0 2px;
		box-shadow: 6px 0 12px 3px rgba(253, 230, 138, 0.7);
	}

	.taillight {
		position: absolute;
		left: 0;
		top: 10px;
		width: 8px;
		height: 9px;
		background: #fca5a5;
		border-radius: 0 2px 2px 0;
	}

	.wheel {
		position: absolute;
		bottom: -14px;
		width: 28px;
		height: 28px;
		background: #1f2937;
		border-radius: 50%;
		border: 4px solid #6b7280;
		animation: spinWheel 0.35s linear infinite;
	}

	.wheel::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		width: 8px;
		height: 8px;
		background: #9ca3af;
		border-radius: 50%;
		transform: translate(-50%, -50%);
	}

	.wheel-back { left: 14px; }
	.wheel-front { right: 14px; }

	.road {
		width: 100%;
		height: 14px;
		background: #374151;
		border-radius: 7px;
		overflow: hidden;
		position: relative;
	}

	.road::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 0;
		height: 3px;
		width: 200%;
		background: repeating-linear-gradient(
			to right,
			#fff 0,
			#fff 22px,
			transparent 22px,
			transparent 44px
		);
		animation: roadSlide 0.4s linear infinite;
	}

	@keyframes carBounce {
		from { transform: translateY(0px); }
		to { transform: translateY(-5px); }
	}

	@keyframes spinWheel {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	@keyframes roadSlide {
		from { transform: translateY(-50%) translateX(0); }
		to { transform: translateY(-50%) translateX(-44px); }
	}
	`}
`;

export const NotFoundTrip = styled.div`
	${({ theme }) => css`
		margin-top: 50px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 24px;
		font-weight: 600;
		color: #545454;
		flex-direction: column;

		@media (max-width: 768px) {
			min-height: calc(100vh - 450px);
			font-size: 18px;
			margin-top: 15px;
		}

		.pesquisa {
			margin-top: 50px;
			height: 50px;
			text-decoration: none;
		}
	`}
`;

export const NotFoundInputTrip = styled(Input)(() => ({
	backgroundColor: "#FFFFFF",
	border: "0.5px solid",
	borderColor: "#828282",
	borderRadius: "10px",
	fontSize: "15px",
	fontWeight: "400",
	width: "auto",
	padding: "3px 10px",
	marginTop: "26px !important",
}));

export const NotFoundInputLabelTrip = styled(InputLabel)(({ theme }) => ({
	fontSize: "20px",
	color: "#5A5A5A",
	fontWeight: "700",
	animation: "none",

	[theme.breakpoints.down("sm")]: {
		fontSize: "16px",
		color: "#5A5A5A",
	},
}));

export const NotFoundContainerFormTrip = styled(Container)(({ theme }) => ({
	width: "100%",
	justifyContent: "space-evenly",
	alignItems: "center",
	display: "flex",
	flexDirection: "row",

	[theme.breakpoints.down("sm")]: {
		marginTop: "10px !important",
		flexDirection: "column",
	},
}));
